<template>
  <ThemeProvider>
    <SidebarProvider>
      <ImpersonationBanner />
      <component :is="EnvBanner" v-if="EnvBanner" />
      <RouterView />
      <HandleAssistant v-if="showAssistant" />
    </SidebarProvider>
  </ThemeProvider>
  <ToastProvider />
  <AppUpdateModal />
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent } from "vue";
import { useRoute } from "vue-router";

import HandleAssistant from "./components/chat/HandleAssistant.vue";
import AppUpdateModal from "./components/common/AppUpdateModal.vue";
import ImpersonationBanner from "./components/common/ImpersonationBanner.vue";
import ToastProvider from "./components/common/ToastProvider.vue";
import SidebarProvider from "./components/layout/SidebarProvider.vue";
import ThemeProvider from "./components/layout/ThemeProvider.vue";
import { useAuthStore } from "./stores/auth";
import { isChatAvailable } from "./utils/chatAccess";

const appEnv = import.meta.env.VITE_APP_ENV;
const envBannerActive =
  Boolean(import.meta.env.VITE_PR_NUMBER) || appEnv === "dev" || appEnv === "staging";

const EnvBanner = envBannerActive
  ? defineAsyncComponent(() => import("./components/common/EnvBanner.vue"))
  : null;

const authStore = useAuthStore();
const route = useRoute();

const handleAssistantBlockRoutes = ["/terms", "/unsubscribe"];

// Only show assistant for authenticated users; who gets chat at all is `isChatAvailable`.
const showAssistant = computed(() => {
  if (!authStore.isAuthenticated) return false;
  if (handleAssistantBlockRoutes.includes(route.path)) return false;
  return isChatAvailable();
});
</script>
